import addEmoji from 'common/assets/icons/add-emoji.svg';
import agentAutomation from 'common/assets/icons/agent-automation.svg';
import atCollab from 'common/assets/icons/at-collab.svg';
import aggregate from 'common/assets/icons/aggregate.svg';
import alert from 'common/assets/icons/alert.svg';
import alertX from 'common/assets/icons/alert-x.svg';
import alertActive from 'common/assets/icons/alert-active.svg';
import alertWarning from 'common/assets/icons/alert-warning.svg';
import alertNormal from 'common/assets/icons/alert-normal.svg';
import alertTilted from 'common/assets/icons/alert-tilted.svg';
import alignCenter from 'common/assets/icons/align-center.svg';
import alignLeft from 'common/assets/icons/align-left.svg';
import alignRight from 'common/assets/icons/align-right.svg';
import analysisCumulative from 'common/assets/icons/analysis-cumulative.svg';
import analysisLinear from 'common/assets/icons/analysis-linear.svg';
import analysisLogarithmic from 'common/assets/icons/analysis-logarithmic.svg';
import analysisRolling from 'common/assets/icons/analysis-rolling.svg';
import analysis from 'common/assets/icons/analysis.svg';
import androidLogo from 'common/assets/icons/android-logo.svg';
import annotation from 'common/assets/icons/annotation.svg';
import anyOrder from 'common/assets/icons/any-order.svg';
import appleLogo from 'common/assets/icons/apple-logo.svg';
import archive from 'common/assets/icons/archive.svg';
import arrowDiagonal from 'common/assets/icons/arrow-diagonal.svg';
import arrowDown from 'common/assets/icons/arrow-down.svg';
import arrowLeft from 'common/assets/icons/arrow-left.svg';
import arrowOverRight from 'common/assets/icons/arrow-over-right.svg';
import arrowReturn from 'common/assets/icons/arrow-return.svg';
import arrowRight from 'common/assets/icons/arrow-right.svg';
import arrowUnlink from 'common/assets/icons/arrow-unlink.svg';
import arrowUp from 'common/assets/icons/arrow-up.svg';
import asanaLogo from 'common/assets/icons/asana-logo.svg';
import attachment from 'common/assets/icons/attachment.svg';
import attributionCustom from 'common/assets/icons/attribution-custom.svg';
import attributionFirstTouch from 'common/assets/icons/attribution-first-touch.svg';
import attributionInverseJShaped from 'common/assets/icons/attribution-inverse-j-shaped.svg';
import attributionJShaped from 'common/assets/icons/attribution-j-shaped.svg';
import attributionLastTouch from 'common/assets/icons/attribution-last-touch.svg';
import attributionLinear from 'common/assets/icons/attribution-linear.svg';
import attributionNumber from 'common/assets/icons/attribution-number.svg';
import attributionParticipation from 'common/assets/icons/attribution-participation.svg';
import attributionString from 'common/assets/icons/attribution-string.svg';
import attributionTimeDecay from 'common/assets/icons/attribution-time-decay.svg';
import attributionUShaped from 'common/assets/icons/attribution-u-shaped.svg';
import autotrack from 'common/assets/icons/autotrack.svg';
import barGraph from 'common/assets/icons/bar-graph.svg';
import barStacked from 'common/assets/icons/bar-stacked.svg';
import bar from 'common/assets/icons/bar.svg';
import betaTag from 'common/assets/icons/beta-tag.svg';
import bigqueryLogo from 'common/assets/icons/bigquery-logo.svg';
import snowflakeLogo from 'common/assets/icons/snowflake-logo.svg';
import behaviorEvent from 'common/assets/icons/behavior-event.svg';
import behaviorEventAddStep from 'common/assets/icons/behavior-event-add-step.svg';
import behaviorEventAnyOrder from 'common/assets/icons/behavior-event-any-order.svg';
import behaviorSimple from 'common/assets/icons/behavior-simple.svg';
import behaviorFunnel from 'common/assets/icons/behavior-funnel.svg';
import behaviorRetention from 'common/assets/icons/behavior-retention.svg';
import blockquote from 'common/assets/icons/blockquote.svg';
import bold from 'common/assets/icons/bold.svg';
import bookmarks from 'common/assets/icons/bookmarks.svg';
import brandAbtest from 'common/assets/icons/brand-abtest.svg';
import brandApplications from 'common/assets/icons/brand-applications.svg';
import brandAudit from 'common/assets/icons/brand-audit.svg';
import brandBarChart from 'common/assets/icons/brand-bar-chart.svg';
import brandCanvas from 'common/assets/icons/brand-canvas.svg';
import brandCanvasSolid from 'common/assets/icons/brand-canvas-solid.svg';
import brandClipboard from 'common/assets/icons/brand-clipboard.svg';
import brandCohorts from 'common/assets/icons/brand-cohorts.svg';
import brandCrown from 'common/assets/icons/brand-crown.svg';
import brandDashboardGray from 'common/assets/icons/brand-dashboard-gray.svg';
import brandDashboard from 'common/assets/icons/brand-dashboard.svg';
import brandDashboardSolid from 'common/assets/icons/brand-dashboard-solid.svg';
import brandDataManagement from 'common/assets/icons/brand-data-management.svg';
import brandExperiments from 'common/assets/icons/brand-experiments.svg';
import brandExplore from 'common/assets/icons/brand-explore.svg';
import brandEye from 'common/assets/icons/brand-eye.svg';
import brandFeatureFlag from 'common/assets/icons/brand-feature-flag.svg';
import brandFlowsLinked from 'common/assets/icons/brand-flows-linked.svg';
import brandFlows from 'common/assets/icons/brand-flows.svg';
import brandFunnelsLinked from 'common/assets/icons/brand-funnels-linked.svg';
import brandFunnels from 'common/assets/icons/brand-funnels.svg';
import brandGem from 'common/assets/icons/brand-gem.svg';
import brandHandHoldingHeart from 'common/assets/icons/brand-hand-holding-heart.svg';
import brandHeatMap from 'common/assets/icons/brand-heat-map.svg';
import brandHeatMapSolid from 'common/assets/icons/brand-heat-map-solid.svg';
import brandHelp from 'common/assets/icons/brand-help.svg';
import brandImpact from 'common/assets/icons/brand-impact.svg';
import brandInsightsLinked from 'common/assets/icons/brand-insights-linked.svg';
import brandInsights from 'common/assets/icons/brand-insights.svg';
import brandIntegrations from 'common/assets/icons/brand-integrations.svg';
import brandJourneys from 'common/assets/icons/brand-journeys.svg';
import brandLaptop from 'common/assets/icons/brand-laptop.svg';
import brandLexicon from 'common/assets/icons/brand-lexicon.svg';
import brandLiveview from 'common/assets/icons/brand-liveview.svg';
import brandMessages from 'common/assets/icons/brand-messages.svg';
import brandLock from 'common/assets/icons/brand-lock.svg';
import brandMixpanel from 'common/assets/icons/brand-mixpanel.svg';
import brandPlug from 'common/assets/icons/brand-plug.svg';
import brandPlugGreen from 'common/assets/icons/brand-plug-green.svg';
import brandRetentionLinked from 'common/assets/icons/brand-retention-linked.svg';
import brandRetention from 'common/assets/icons/brand-retention.svg';
import brandSearch from 'common/assets/icons/brand-search.svg';
import brandSessionReplay from 'common/assets/icons/brand-session-replay.svg';
import brandSettings from 'common/assets/icons/brand-settings.svg';
import brandShield from 'common/assets/icons/brand-shield.svg';
import brandSignal from 'common/assets/icons/brand-signal.svg';
import brandUpgrade from 'common/assets/icons/brand-upgrade.svg';
import braveLogo from 'common/assets/icons/brave-logo.svg';
import browser from 'common/assets/icons/browser.svg';
import bucketing from 'common/assets/icons/bucketing.svg';
import calendar from 'common/assets/icons/calendar.svg';
import caretDown from 'common/assets/icons/caret-down.svg';
import caretLeft from 'common/assets/icons/caret-left.svg';
import caretRight from 'common/assets/icons/caret-right.svg';
import caretUp from 'common/assets/icons/caret-up.svg';
import checkmark from 'common/assets/icons/checkmark.svg';
import circleCheckmark from 'common/assets/icons/circle-checkmark.svg';
import circleCheckmarkGreen from 'common/assets/icons/circle-checkmark-green.svg';
import circleCheckmarkGrey from 'common/assets/icons/circle-checkmark-grey.svg';
import circleCheckmarkPurple from 'common/assets/icons/circle-checkmark-purple.svg';
import circleClear from 'common/assets/icons/circle-clear.svg';
import circleDashed from 'common/assets/icons/circle-dashed.svg';
import circleDecrease from 'common/assets/icons/circle-decrease.svg';
import circleDrop from 'common/assets/icons/circle-drop.svg';
import circleIncrease from 'common/assets/icons/circle-increase.svg';
import circleQuestion from 'common/assets/icons/circle-question.svg';
import circle from 'common/assets/icons/circle.svg';
import chartColor from 'common/assets/icons/chart-color.svg';
import chatgpt from 'common/assets/icons/chatgpt.svg';
import chromeLogo from 'common/assets/icons/chrome-logo.svg';
import claude from 'common/assets/icons/claude.svg';
import clickmap from 'common/assets/icons/clickmap.svg';
import codex from 'common/assets/icons/codex.svg';
import coding from 'common/assets/icons/coding.svg';
import collapse from 'common/assets/icons/collapse.svg';
import collapseDiagonal from 'common/assets/icons/collapse-diagonal.svg';
import columnSelect from 'common/assets/icons/column-select.svg';
import comment from 'common/assets/icons/comment.svg';
import computed from 'common/assets/icons/computed.svg';
import community from 'common/assets/icons/community.svg';
import compose from 'common/assets/icons/compose.svg';
import config from 'common/assets/icons/config.svg';
import copilotConversation from 'common/assets/icons/copilot-conversation.svg';
import conversionFirstStep from 'common/assets/icons/conversion-first-step.svg';
import conversionPrevStep from 'common/assets/icons/conversion-prev-step.svg';
import copy from 'common/assets/icons/copy.svg';
import correlate from 'common/assets/icons/correlate.svg';
import crosshairs from 'common/assets/icons/crosshairs.svg';
import cubeDotted from 'common/assets/icons/cube-dotted.svg';
import cubeFilled from 'common/assets/icons/cube-filled.svg';
import cubeOutlined from 'common/assets/icons/cube-outlined.svg';
import cursor from 'common/assets/icons/cursor.svg';
import cursorLogo from 'common/assets/icons/cursor-logo.svg';
import cursorOutlined from 'common/assets/icons/cursor-outlined.svg';
import customEventBeta from 'common/assets/icons/custom-event-beta.svg';
import customEvents from 'common/assets/icons/custom-events.svg';
import customSegments from 'common/assets/icons/custom-segments.svg';
import custom from 'common/assets/icons/custom.svg';
import dash from 'common/assets/icons/dash.svg';
import dashboard from 'common/assets/icons/dashboard.svg';
import databricksLogo from 'common/assets/icons/databricks-logo.svg';
import dataMetric from 'common/assets/icons/data-metric.svg';
import dataMetricDashed from 'common/assets/icons/data-metric-dashed.svg';
import dataMetricOutlined from 'common/assets/icons/data-metric-outlined.svg';
import dataset from 'common/assets/icons/dataset.svg';
import darkMode from 'common/assets/icons/dark-mode.svg';
import deadclick from 'common/assets/icons/deadclick.svg';
import diff from 'common/assets/icons/diff.svg';
import discover from 'common/assets/icons/discover.svg';
import documentation from 'common/assets/icons/documentation.svg';
import doubleCaret from 'common/assets/icons/double-caret.svg';
import dragHand from 'common/assets/icons/drag-hand.svg';
import duplicate from 'common/assets/icons/duplicate.svg';
import edgeLogo from 'common/assets/icons/edge-logo.svg';
import edit from 'common/assets/icons/edit.svg';
import ellipsis from 'common/assets/icons/ellipsis.svg';
import email from 'common/assets/icons/email.svg';
import event from 'common/assets/icons/event.svg';
import eventAttribute from 'common/assets/icons/event-attribute.svg';
import eventSampling from 'common/assets/icons/event-sampling.svg';
import expand from 'common/assets/icons/expand.svg';
import exportCsv from 'common/assets/icons/export-csv.svg';
import exportIcon from 'common/assets/icons/export.svg';
import exportPdf from 'common/assets/icons/export-pdf.svg';
import exportPng from 'common/assets/icons/export-png.svg';
import exportSecondary from 'common/assets/icons/export-secondary.svg';
import externalLink from 'common/assets/icons/external-link.svg';
import eyeHide from 'common/assets/icons/eye-hide.svg';
import eyeOn from 'common/assets/icons/eye-on.svg';
import featureTour from 'common/assets/icons/feature-tour.svg';
import feed from 'common/assets/icons/feed.svg';
import feedback from 'common/assets/icons/feedback.svg';
import filledHeart from 'common/assets/icons/filled-heart.svg';
import filledPin from 'common/assets/icons/filled-pin.svg';
import filledSampling from 'common/assets/icons/filled-sampling.svg';
import filterXs from 'common/assets/icons/filter-xs.svg';
import filter from 'common/assets/icons/filter.svg';
import fire from 'common/assets/icons/fire.svg';
import firefoxLogo from 'common/assets/icons/firefox-logo.svg';
import flag from 'common/assets/icons/flag.svg';
import flowsTab from 'common/assets/icons/flows-tab.svg';
import formula from 'common/assets/icons/formula.svg';
import funnelSteps from 'common/assets/icons/funnel-steps.svg';
import funnelsTab from 'common/assets/icons/funnels-tab.svg';
import gem from 'common/assets/icons/gem.svg';
import gemini from 'common/assets/icons/gemini.svg';
import githubLogo from 'common/assets/icons/github-logo.svg';
import globe from 'common/assets/icons/globe.svg';
import gripper from 'common/assets/icons/gripper.svg';
import gripperXs from 'common/assets/icons/gripper-xs.svg';
import groupAttribute from 'common/assets/icons/group-attribute.svg';
import handTool from 'common/assets/icons/hand-tool.svg';
import heart from 'common/assets/icons/heart.svg';
import heatMap from 'common/assets/icons/heat-map.svg';
import helpCenter from 'common/assets/icons/help-center.svg';
import history from 'common/assets/icons/history.svg';
import home from 'common/assets/icons/home.svg';
import horEllipsis from 'common/assets/icons/hor-ellipsis.svg';
import iconGrid from 'common/assets/icons/icon-grid.svg';
import experiment from 'common/assets/icons/experiment.svg';
import featureFlag from 'common/assets/icons/feature-flag.svg';
import ideaBlended from 'common/assets/icons/idea-blended.svg';
import idea from 'common/assets/icons/idea.svg';
import image from 'common/assets/icons/image.svg';
import imageTool from 'common/assets/icons/image-tool.svg';
import impact from 'common/assets/icons/impact.svg';
import inapp from 'common/assets/icons/inapp.svg';
import infoXs from 'common/assets/icons/info-xs.svg';
import info from 'common/assets/icons/info.svg';
import input from 'common/assets/icons/input.svg';
import insights from 'common/assets/icons/insights.svg';
import insightsTab from 'common/assets/icons/insights-tab.svg';
import install from 'common/assets/icons/install.svg';
import integrations from 'common/assets/icons/integrations.svg';
import invite from 'common/assets/icons/invite.svg';
import italic from 'common/assets/icons/italic.svg';
import jumpLeft from 'common/assets/icons/jump-left.svg';
import jumpRight from 'common/assets/icons/jump-right.svg';
import launch from 'common/assets/icons/launch.svg';
import laptop from 'common/assets/icons/laptop.svg';
import layoutBottom from 'common/assets/icons/layout-bottom.svg';
import layoutMiddle from 'common/assets/icons/layout-middle.svg';
import layoutTop from 'common/assets/icons/layout-top.svg';
import leftAlign from 'common/assets/icons/left-align.svg';
import leftPanel from 'common/assets/icons/left-panel.svg';
import leftPanelHover from 'common/assets/icons/left-panel-hover.svg';
import lift from 'common/assets/icons/lift.svg';
import lightningBolt from 'common/assets/icons/lightning-bolt.svg';
import lightMode from 'common/assets/icons/light-mode.svg';
import changelog from 'common/assets/icons/changelog.svg';
import plansAndBilling from 'common/assets/icons/plans-and-billing.svg';
import line from 'common/assets/icons/line.svg';
import lineIndicator from 'common/assets/icons/line_indicator.svg';
import linkOut from 'common/assets/icons/link-out.svg';
import link from 'common/assets/icons/link.svg';
import location from 'common/assets/icons/location.svg';
import lock from 'common/assets/icons/lock.svg';
import lookup from 'common/assets/icons/lookup.svg';
import notionLogo from 'common/assets/icons/notion-logo.svg';
import jiraLogo from 'common/assets/icons/jira-logo.svg';
import markedRead from 'common/assets/icons/marked-read.svg';
import merge from 'common/assets/icons/merge.svg';
import metricFunnel from 'common/assets/icons/metric-funnel.svg';
import metricRetention from 'common/assets/icons/metric-retention.svg';
import metricSaved from 'common/assets/icons/metric-saved.svg';
import metricSimple from 'common/assets/icons/metric-simple.svg';
import metricTool from 'common/assets/icons/metric-tool.svg';
import metricUnsaved from 'common/assets/icons/metric-unsaved.svg';
import mixpanelLogo from 'common/assets/icons/mixpanel-logo.svg';
import mobile from 'common/assets/icons/mobile.svg';
import newReport from 'common/assets/icons/new-report.svg';
import noAttribution from 'common/assets/icons/no-attribution.svg';
import note from 'common/assets/icons/note.svg';
import noteTool from 'common/assets/icons/note-tool.svg';
import numberedList from 'common/assets/icons/numbered-list.svg';
import open from 'common/assets/icons/open.svg';
import operaLogo from 'common/assets/icons/opera-logo.svg';
import opportunity from 'common/assets/icons/opportunity.svg';
import optOut from 'common/assets/icons/opt-out.svg';
import os from 'common/assets/icons/os.svg';
import pause from 'common/assets/icons/pause.svg';
import person from 'common/assets/icons/person.svg';
import pie from 'common/assets/icons/pie.svg';
import pin from 'common/assets/icons/pin.svg';
import play from 'common/assets/icons/play.svg';
import playVideo from 'common/assets/icons/play-video.svg';
import plus from 'common/assets/icons/plus.svg';
import postgresLogo from 'common/assets/icons/postgres-logo.svg';
import profileAttribute from 'common/assets/icons/profile-attribute.svg';
import profile from 'common/assets/icons/profile.svg';
import pureTextNode from 'common/assets/icons/pure-text-node.svg';
import pulse from 'common/assets/icons/pulse.svg';
import pulseAnimation from 'common/assets/icons/pulse-animation.svg';
import pushDown from 'common/assets/icons/push-down.svg';
import pushLeft from 'common/assets/icons/push-left.svg';
import pushRight from 'common/assets/icons/push-right.svg';
import pushUp from 'common/assets/icons/push-up.svg';
import push from 'common/assets/icons/push.svg';
import rageclick from 'common/assets/icons/rageclick.svg';
import redo from 'common/assets/icons/redo.svg';
import redshiftLogo from 'common/assets/icons/redshift-logo.svg';
import reset from 'common/assets/icons/reset.svg';
import refresh from 'common/assets/icons/refresh.svg';
import relevancy from 'common/assets/icons/relevancy.svg';
import replay from 'common/assets/icons/replay.svg';
import report from 'common/assets/icons/report.svg';
import restart from 'common/assets/icons/restart.svg';
import restore from 'common/assets/icons/restore.svg';
import retentionCurve from 'common/assets/icons/retention-curve.svg';
import retentionTab from 'common/assets/icons/retention-tab.svg';
import runtimeEvent from 'common/assets/icons/runtime-event.svg';
import rightAlign from 'common/assets/icons/right-align.svg';
import rightPanel from 'common/assets/icons/right-panel.svg';
import rightPanelHover from 'common/assets/icons/right-panel-hover.svg';
import running from 'common/assets/icons/running.svg';
import safariLogo from 'common/assets/icons/safari-logo.svg';
import sampling from 'common/assets/icons/sampling.svg';
import save from 'common/assets/icons/save.svg';
import scrollmap from 'common/assets/icons/scrollmap.svg';
import search from 'common/assets/icons/search.svg';
import segment from 'common/assets/icons/segment.svg';
import selectTool from 'common/assets/icons/select-tool.svg';
import sent from 'common/assets/icons/sent.svg';
import settings from 'common/assets/icons/settings.svg';
import settingsSmall from 'common/assets/icons/settings-small.svg';
import setupGuide from 'common/assets/icons/setup-guide.svg';
import share from 'common/assets/icons/share.svg';
import singleMetric from 'common/assets/icons/single-metric.svg';
import singleReplay from 'common/assets/icons/single-replay.svg';
import slackLogo from 'common/assets/icons/slack-logo.svg';
import sms from 'common/assets/icons/sms.svg';
import sortAlphaAsc from 'common/assets/icons/sort-alpha-asc.svg';
import sortAlphaDesc from 'common/assets/icons/sort-alpha-desc.svg';
import sortValueAsc from 'common/assets/icons/sort-value-asc.svg';
import sortValueDesc from 'common/assets/icons/sort-value-desc.svg';
import sort from 'common/assets/icons/sort.svg';
import spark from 'common/assets/icons/spark.svg';
import sparkColor from 'common/assets/icons/spark-color.svg';
import spinner from 'common/assets/icons/spinner.svg';
import stackedLine from 'common/assets/icons/stacked-line.svg';
import starTopEvents from 'common/assets/icons/star-top-events.svg';
import statusLight from 'common/assets/icons/status-light.svg';
import stickyNote from 'common/assets/icons/sticky-note.svg';
import stopGenerating from 'common/assets/icons/stop-generating.svg';
import stopWatch from 'common/assets/icons/stop-watch.svg';
import strategyTool from 'common/assets/icons/strategy-tool.svg';
import strikethrough from 'common/assets/icons/strikethrough.svg';
import subtitle from 'common/assets/icons/subtitle.svg';
import switchEmpty from 'common/assets/icons/switch-empty.svg';
import switchOff from 'common/assets/icons/switch-off.svg';
import switchOn from 'common/assets/icons/switch-on.svg';
import table from 'common/assets/icons/table.svg';
import tag from 'common/assets/icons/tag.svg';
import team from 'common/assets/icons/team.svg';
import template from 'common/assets/icons/template.svg';
import textDash from 'common/assets/icons/text-dash.svg';
import textHighlight from 'common/assets/icons/text-highlight.svg';
import text from 'common/assets/icons/text.svg';
import textTool from 'common/assets/icons/text-tool.svg';
import thumbsDown from 'common/assets/icons/thumbs-down.svg';
import thumbsUp from 'common/assets/icons/thumbs-up.svg';
import timeFirstStep from 'common/assets/icons/time-first-step.svg';
import timePrevStep from 'common/assets/icons/time-prev-step.svg';
import time from 'common/assets/icons/time.svg';
import title from 'common/assets/icons/title.svg';
import topPaths from 'common/assets/icons/top-paths.svg';
import trashcan from 'common/assets/icons/trashcan.svg';
import triangleDown from 'common/assets/icons/triangle-down.svg';
import triangleUp from 'common/assets/icons/triangle-up.svg';
import tvMode from 'common/assets/icons/tv-mode.svg';
import typeBoolean from 'common/assets/icons/type-boolean.svg';
import typeCustomBoolean from 'common/assets/icons/type-custom-boolean.svg';
import typeCustomDate from 'common/assets/icons/type-custom-date.svg';
import typeCustomList from 'common/assets/icons/type-custom-list.svg';
import typeCustomNumber from 'common/assets/icons/type-custom-number.svg';
import typeCustomText from 'common/assets/icons/type-custom-text.svg';
import typeDate from 'common/assets/icons/type-date.svg';
import typeHistoricBoolean from 'common/assets/icons/type-historic-boolean.svg';
import typeHistoricDate from 'common/assets/icons/type-historic-date.svg';
import typeHistoricNumber from 'common/assets/icons/type-historic-number.svg';
import typeHistoricText from 'common/assets/icons/type-historic-text.svg';
import typeList from 'common/assets/icons/type-list.svg';
import typeNumber from 'common/assets/icons/type-number.svg';
import typeObject from 'common/assets/icons/type-object.svg';
import typeText from 'common/assets/icons/type-text.svg';
import twoTone from 'common/assets/icons/two-tone.svg';
import ubuntuLogo from 'common/assets/icons/ubuntu-logo.svg';
import underline from 'common/assets/icons/underline.svg';
import undo from 'common/assets/icons/undo.svg';
import unlock from 'common/assets/icons/unlock.svg';
import unmerge from 'common/assets/icons/unmerge.svg';
import user from 'common/assets/icons/user.svg';
import users from 'common/assets/icons/users.svg';
import valueAbsolute from 'common/assets/icons/value-absolute.svg';
import valueRelative from 'common/assets/icons/value-relative.svg';
import verifiedFilled from 'common/assets/icons/verified-filled.svg';
import verifiedOutlined from 'common/assets/icons/verified-outlined.svg';
import column from 'common/assets/icons/column.svg';
import columnStacked from 'common/assets/icons/column-stacked.svg';
import warning from 'common/assets/icons/warning.svg';
import warningFilled from 'common/assets/icons/warning-filled.svg';
import wave from 'common/assets/icons/wave.svg';
import webhook from 'common/assets/icons/webhook.svg';
import windowsLogo from 'common/assets/icons/windows-logo.svg';
import x from 'common/assets/icons/x.svg';
import zoomToFit from 'common/assets/icons/zoom-to-fit.svg';

export const SVG_ICONS = {
  'add-emoji': addEmoji,
  'agent-automation': agentAutomation,
  'at-collab': atCollab,
  aggregate,
  alert,
  'alert-x': alertX,
  'alert-active': alertActive,
  'alert-normal': alertNormal,
  'alert-warning': alertWarning,
  'alert-tilted': alertTilted,
  'align-center': alignCenter,
  'align-left': alignLeft,
  'align-right': alignRight,
  'analysis-cumulative': analysisCumulative,
  'analysis-linear': analysisLinear,
  'analysis-logarithmic': analysisLogarithmic,
  'analysis-rolling': analysisRolling,
  analysis,
  'android-logo': androidLogo,
  annotation,
  'any-order': anyOrder,
  'apple-logo': appleLogo,
  archive,
  'arrow-diagonal': arrowDiagonal,
  'arrow-down': arrowDown,
  'arrow-left': arrowLeft,
  'arrow-over-right': arrowOverRight,
  'arrow-return': arrowReturn,
  'arrow-right': arrowRight,
  'arrow-unlink': arrowUnlink,
  'arrow-up': arrowUp,
  'asana-logo': asanaLogo,
  attachment,
  'attribution-custom': attributionCustom,
  'attribution-first-touch': attributionFirstTouch,
  'attribution-inverse-j-shaped': attributionInverseJShaped,
  'attribution-j-shaped': attributionJShaped,
  'attribution-last-touch': attributionLastTouch,
  'attribution-linear': attributionLinear,
  'attribution-number': attributionNumber,
  'attribution-participation': attributionParticipation,
  'attribution-string': attributionString,
  'attribution-time-decay': attributionTimeDecay,
  'attribution-u-shaped': attributionUShaped,
  autotrack,
  'bar-graph': barGraph,
  'bar-stacked': barStacked,
  bar,
  'beta-tag': betaTag,
  'behavior-event': behaviorEvent,
  'behavior-event-add-step': behaviorEventAddStep,
  'behavior-event-any-order': behaviorEventAnyOrder,
  'behavior-simple': behaviorSimple,
  'behavior-funnel': behaviorFunnel,
  'behavior-retention': behaviorRetention,
  'bigquery-logo': bigqueryLogo,
  blockquote,
  bold,
  bookmarks,
  'brand-abtest': brandAbtest,
  'brand-applications': brandApplications,
  'brand-audit': brandAudit,
  'brand-bar-chart': brandBarChart,
  'brand-canvas': brandCanvas,
  'brand-canvas-solid': brandCanvasSolid,
  'brand-clipboard': brandClipboard,
  'brand-cohorts': brandCohorts,
  'brand-crown': brandCrown,
  'brand-dashboard-gray': brandDashboardGray,
  'brand-dashboard': brandDashboard,
  'brand-dashboard-solid': brandDashboardSolid,
  'brand-data-management': brandDataManagement,
  'brand-experiments': brandExperiments,
  'brand-explore': brandExplore,
  'brand-eye': brandEye,
  'brand-feature-flag': brandFeatureFlag,
  'brand-flows-linked': brandFlowsLinked,
  'brand-flows': brandFlows,
  'brand-funnels-linked': brandFunnelsLinked,
  'brand-funnels': brandFunnels,
  'brand-gem': brandGem,
  'brand-hand-holding-heart': brandHandHoldingHeart,
  'brand-heat-map': brandHeatMap,
  'brand-heat-map-solid': brandHeatMapSolid,
  'brand-help': brandHelp,
  'brand-impact': brandImpact,
  'brand-insights-linked': brandInsightsLinked,
  'brand-insights': brandInsights,
  'brand-integrations': brandIntegrations,
  'brand-journeys': brandJourneys,
  'brand-laptop': brandLaptop,
  'brand-lexicon': brandLexicon,
  'brand-liveview': brandLiveview,
  'brand-lock': brandLock,
  'brand-messages': brandMessages,
  'brand-mixpanel': brandMixpanel,
  'brand-plug': brandPlug,
  'brand-plug-green': brandPlugGreen,
  'brand-retention-linked': brandRetentionLinked,
  'brand-retention': brandRetention,
  'brand-search': brandSearch,
  'brand-session-replay': brandSessionReplay,
  'brand-settings': brandSettings,
  'brand-shield': brandShield,
  'brand-signal': brandSignal,
  'brand-upgrade': brandUpgrade,
  'brave-logo': braveLogo,
  browser,
  bucketing,
  calendar,
  'caret-down': caretDown,
  'caret-left': caretLeft,
  'caret-right': caretRight,
  'caret-up': caretUp,
  clickmap,
  checkmark,
  changelog,
  'chart-color': chartColor,
  chatgpt,
  'chrome-logo': chromeLogo,
  claude,
  'circle-checkmark': circleCheckmark,
  'circle-checkmark-green': circleCheckmarkGreen,
  'circle-checkmark-grey': circleCheckmarkGrey,
  'circle-checkmark-purple': circleCheckmarkPurple,
  'circle-clear': circleClear,
  'circle-dashed': circleDashed,
  'circle-decrease': circleDecrease,
  'circle-drop': circleDrop,
  'circle-increase': circleIncrease,
  'circle-question': circleQuestion,
  circle,
  codex,
  coding,
  collapse,
  'collapse-diagonal': collapseDiagonal,
  'column-select': columnSelect,
  comment,
  computed,
  community,
  compose,
  config,
  'copilot-conversation': copilotConversation,
  'conversion-first-step': conversionFirstStep,
  'conversion-prev-step': conversionPrevStep,
  copy,
  correlate,
  crosshairs,
  'cube-dotted': cubeDotted,
  'cube-filled': cubeFilled,
  'cube-outlined': cubeOutlined,
  cursor,
  'cursor-logo': cursorLogo,
  'cursor-outlined': cursorOutlined,
  'custom-event-beta': customEventBeta,
  'custom-events': customEvents,
  'custom-segments': customSegments,
  custom,
  dash,
  dashboard,
  'databricks-logo': databricksLogo,
  'data-metric': dataMetric,
  'data-metric-dashed': dataMetricDashed,
  'data-metric-outlined': dataMetricOutlined,
  dataset,
  'dark-mode': darkMode,
  deadclick,
  diff,
  discover,
  documentation,
  'double-caret': doubleCaret,
  'drag-hand': dragHand,
  duplicate,
  'edge-logo': edgeLogo,
  edit,
  ellipsis,
  email,
  event,
  'event-attribute': eventAttribute,
  'event-sampling': eventSampling,
  expand,
  experiment,
  'export-csv': exportCsv,
  'export-pdf': exportPdf,
  'export-png': exportPng,
  'export-secondary': exportSecondary,
  export: exportIcon,
  externalLink,
  'eye-hide': eyeHide,
  'eye-on': eyeOn,
  'feature-flag': featureFlag,
  'feature-tour': featureTour,
  feed,
  feedback,
  'filled-heart': filledHeart,
  'filled-pin': filledPin,
  'filled-sampling': filledSampling,
  'filter-xs': filterXs,
  filter,
  fire,
  'firefox-logo': firefoxLogo,
  flag,
  'flows-tab': flowsTab,
  formula,
  'funnel-steps': funnelSteps,
  'funnels-tab': funnelsTab,
  gem,
  gemini,
  'github-logo': githubLogo,
  globe,
  'gripper-xs': gripperXs,
  gripper,
  'group-attribute': groupAttribute,
  'hand-tool': handTool,
  heart,
  'heat-map': heatMap,
  'help-center': helpCenter,
  history,
  home,
  'hor-ellipsis': horEllipsis,
  'idea-blended': ideaBlended,
  idea,
  'icon-grid': iconGrid,
  image,
  'image-tool': imageTool,
  impact,
  inapp,
  'info-xs': infoXs,
  info,
  input,
  insights,
  'insights-tab': insightsTab,
  install,
  integrations,
  invite,
  italic,
  'jump-left': jumpLeft,
  'jump-right': jumpRight,
  laptop,
  launch,
  'layout-bottom': layoutBottom,
  'layout-middle': layoutMiddle,
  'layout-top': layoutTop,
  'left-align': leftAlign,
  'left-panel': leftPanel,
  'left-panel-hover': leftPanelHover,
  lift,
  'lightning-bolt': lightningBolt,
  'light-mode': lightMode,
  line,
  'line-indicator': lineIndicator,
  link,
  'link-out': linkOut,
  location,
  lock,
  lookup,
  'marked-read': markedRead,
  merge,
  'metric-funnel': metricFunnel,
  'metric-retention': metricRetention,
  'metric-saved': metricSaved,
  'metric-simple': metricSimple,
  'metric-tool': metricTool,
  'metric-unsaved': metricUnsaved,
  'mixpanel-logo': mixpanelLogo,
  mobile,
  'new-report': newReport,
  'notion-logo': notionLogo,
  'jira-logo': jiraLogo,
  'no-attribution': noAttribution,
  note,
  'note-tool': noteTool,
  'numbered-list': numberedList,
  open,
  'opera-logo': operaLogo,
  opportunity,
  'opt-out': optOut,
  os,
  pause,
  person,
  pie,
  pin,
  'plans-and-billing': plansAndBilling,
  play,
  'play-video': playVideo,
  plus,
  'postgres-logo': postgresLogo,
  'profile-attribute': profileAttribute,
  profile,
  pulse,
  'pulse-animation': pulseAnimation,
  'pure-text-node': pureTextNode,
  'push-down': pushDown,
  'push-left': pushLeft,
  'push-right': pushRight,
  'push-up': pushUp,
  push,
  rageclick,
  redo,
  'redshift-logo': redshiftLogo,
  reset,
  refresh,
  relevancy,
  replay,
  report,
  restart,
  restore,
  'retention-curve': retentionCurve,
  'retention-tab': retentionTab,
  'runtime-event': runtimeEvent,
  'right-align': rightAlign,
  'right-panel': rightPanel,
  'right-panel-hover': rightPanelHover,
  running,
  'safari-logo': safariLogo,
  sampling,
  scrollmap,
  save,
  search,
  segment,
  'select-tool': selectTool,
  sent,
  settings,
  'settings-small': settingsSmall,
  'setup-guide': setupGuide,
  share,
  'single-metric': singleMetric,
  'single-replay': singleReplay,
  'slack-logo': slackLogo,
  sms,
  'sort-alpha-asc': sortAlphaAsc,
  'sort-alpha-desc': sortAlphaDesc,
  'sort-value-asc': sortValueAsc,
  'sort-value-desc': sortValueDesc,
  'snowflake-logo': snowflakeLogo,
  sort,
  spark,
  'spark-color': sparkColor,
  spinner,
  'stacked-line': stackedLine,
  'star-top-events': starTopEvents,
  'status-light': statusLight,
  'sticky-note': stickyNote,
  'stop-generating': stopGenerating,
  'stop-watch': stopWatch,
  'strategy-tool': strategyTool,
  strikethrough,
  subtitle,
  'switch-empty': switchEmpty,
  'switch-off': switchOff,
  'switch-on': switchOn,
  table,
  tag,
  team,
  template,
  'text-dash': textDash,
  'text-highlight': textHighlight,
  text,
  'text-tool': textTool,
  'thumbs-down': thumbsDown,
  'thumbs-up': thumbsUp,
  'time-first-step': timeFirstStep,
  'time-prev-step': timePrevStep,
  time,
  title,
  'top-paths': topPaths,
  trashcan,
  'triangle-down': triangleDown,
  'triangle-up': triangleUp,
  'tv-mode': tvMode,
  'type-boolean': typeBoolean,
  'type-custom-boolean': typeCustomBoolean,
  'type-custom-date': typeCustomDate,
  'type-custom-list': typeCustomList,
  'type-custom-number': typeCustomNumber,
  'type-custom-text': typeCustomText,
  'type-date': typeDate,
  'type-historic-boolean': typeHistoricBoolean,
  'type-historic-date': typeHistoricDate,
  'type-historic-number': typeHistoricNumber,
  'type-historic-text': typeHistoricText,
  'type-list': typeList,
  'type-number': typeNumber,
  'type-object': typeObject,
  'type-text': typeText,
  'two-tone': twoTone,
  'ubuntu-logo': ubuntuLogo,
  underline,
  undo,
  unlock,
  unmerge,
  user,
  users,
  'value-absolute': valueAbsolute,
  'value-relative': valueRelative,
  'verified-filled': verifiedFilled,
  'verified-outlined': verifiedOutlined,
  column,
  'column-stacked': columnStacked,
  warning,
  'warning-filled': warningFilled,
  wave,
  webhook,
  'windows-logo': windowsLogo,
  x,
  'zoom-to-fit': zoomToFit,
} as const;

export const SVG_ICON_NAMES = Object.keys(SVG_ICONS) as Array<keyof typeof SVG_ICONS>;
